module.exports = __webpack_public_path__ + "img/arrow-down-white.c7ea9d18.svg";